import { render, staticRenderFns } from "./OdontogramaGerenciarCobrancasTabela.vue?vue&type=template&id=3a7d9b3e&scoped=true"
import script from "./OdontogramaGerenciarCobrancasTabela.vue?vue&type=script&lang=js"
export * from "./OdontogramaGerenciarCobrancasTabela.vue?vue&type=script&lang=js"
import style0 from "./OdontogramaGerenciarCobrancasTabela.vue?vue&type=style&index=0&id=3a7d9b3e&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7d9b3e",
  null
  
)

export default component.exports